const dollarFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});
export const formatToDollarsString = (amount: number) =>
  dollarFormatter.format(amount);
